<template>

    <!-- Common Banner Area -->
    <NoFlightConfirmationBanner />

    <!-- No Flight Confirmation Submission Areas -->
    <NoFlightConfirmation />

</template>
<script>
import NoFlightConfirmationBanner from '@/components/no-flights/NoFlightConfirmationBanner.vue'
import NoFlightConfirmation from '@/components/no-flights/NoFlightConfirmation.vue'

export default {
    name: "NoFlightConfirmationView",
    components: {
        NoFlightConfirmationBanner, NoFlightConfirmation
    }
};
</script>